import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { Macro } from 'app/Model/ui/Macro';

@Component({
    selector: 'userAction-convertPictures',
    templateUrl: 'userAction-convertPictures.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionConvertPicturesComponent) }
    ],
    standalone: false
})
export class UserActionConvertPicturesComponent extends UserActionBaseComponent {
  _imageTypes: string[] = ['jpg', 'png'];
  _imageType: string = 'jpg';
  _maxResolution: number = 1920;

  imageSquare = false;
  imageBgColor = '#FFFFFF';

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService
  ) {
    super(loginService, macroService);
  }

  get imageTypes(): string[] {
    return this._imageTypes;
  }

  get imageType(): string {
    return this._imageType;
  }

  set imageType(value: string) {
    this._imageType = value;
  }

  get maxResolution(): number {
    return this._maxResolution;
  }

  set maxResolution(value: number) {
    this._maxResolution = value;
  }

  public getActionId(macro:Macro):string {
    return 'ResizeImages(' +
    this.maxResolution +
    ':' +
    this.imageType +
    ':' +
    (this.imageSquare ? 1 : 0) +
    ':' +
    this.imageBgColor +
    ')';
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({maxResolution: this.maxResolution,imageType: this.imageType, imageSquare: this.imageSquare, imageBgColor: this.imageBgColor});
  }
  public parseParameter(parameter: string) {
    const params = JSON.parse(parameter);
    this.maxResolution = params.maxResolution;
    this.imageType = params.imageType;
    this.imageSquare = params.imageSquare;
    this.imageBgColor = params.imageBgColor;
    
  }
}
/*
  _imageTypes: string[] = ['jpg', 'png'];
  _imageType: string = 'jpg';
  _maxResolution: number = 1920;

  imageSquare = false;
  imageBgColor = '#FFFFFF';*/
